import store from '@/store';
import { isCorporateEnvironment } from './environment';

/**
 * Permissões de sistema corporativo (não confundir com cargo orgânico).
 * gestor | coordenador | colaborador
 */
export const CORPORATE_PERMISSIONS = {
    GESTOR: 'gestor',
    COORDENADOR: 'coordenador',
    COLABORADOR: 'colaborador',
};

const LEGACY_MAP = {
    admin_corporate: CORPORATE_PERMISSIONS.GESTOR,
    manager: CORPORATE_PERMISSIONS.COORDENADOR,
    collaborator: CORPORATE_PERMISSIONS.COLABORADOR,
};

export function getCorporatePermission(user = store.state?.user) {
    if (!user) {
        return null;
    }
    const raw = user.corporatePermission || user.corporateRole || null;
    if (raw) {
        return LEGACY_MAP[raw] || raw;
    }
    // Fallback mock: admins Weeduc (type 1/2) atuam como gestor
    if (user.type === 1 || user.type === 2) {
        return CORPORATE_PERMISSIONS.GESTOR;
    }
    if (user.type === 3) {
        return CORPORATE_PERMISSIONS.COLABORADOR;
    }
    return null;
}

/** @deprecated use getCorporatePermission */
export function getCorporateRole(user = store.state?.user) {
    return getCorporatePermission(user);
}

export function canAccessCorporateArea(user = store.state?.user) {
    const permission = getCorporatePermission(user);
    return (
        isCorporateEnvironment()
        && (permission === CORPORATE_PERMISSIONS.GESTOR
            || permission === CORPORATE_PERMISSIONS.COORDENADOR)
    );
}

export function canManageCorporateStructure(user = store.state?.user) {
    return getCorporatePermission(user) === CORPORATE_PERMISSIONS.GESTOR;
}

export function canManageCorporateCourses(user = store.state?.user) {
    return getCorporatePermission(user) === CORPORATE_PERMISSIONS.GESTOR;
}

export function canManageCourseGroups(user = store.state?.user) {
    return getCorporatePermission(user) === CORPORATE_PERMISSIONS.GESTOR;
}

export function canManageGamification(user = store.state?.user) {
    return getCorporatePermission(user) === CORPORATE_PERMISSIONS.GESTOR;
}

export function canViewCorporateTeam(user = store.state?.user) {
    const permission = getCorporatePermission(user);
    return (
        permission === CORPORATE_PERMISSIONS.GESTOR
        || permission === CORPORATE_PERMISSIONS.COORDENADOR
    );
}

export function canViewOnlyOwnCorporateData(user = store.state?.user) {
    return getCorporatePermission(user) === CORPORATE_PERMISSIONS.COLABORADOR;
}

export function canConfigureCorporate(user = store.state?.user) {
    return getCorporatePermission(user) === CORPORATE_PERMISSIONS.GESTOR;
}

export function canPreviewAsCollaborator(user = store.state?.user) {
    const permission = getCorporatePermission(user);
    return (
        permission === CORPORATE_PERMISSIONS.GESTOR
        || permission === CORPORATE_PERMISSIONS.COORDENADOR
    );
}

export default {
    CORPORATE_PERMISSIONS,
    getCorporatePermission,
    getCorporateRole,
    canAccessCorporateArea,
    canManageCorporateStructure,
    canManageCorporateCourses,
    canManageCourseGroups,
    canManageGamification,
    canViewCorporateTeam,
    canViewOnlyOwnCorporateData,
    canConfigureCorporate,
    canPreviewAsCollaborator,
};
